import ChartColorPicker from './ChartColorPicker'

export default ChartColorPicker
